export default __webpack_public_path__ + "static/media/zine-avatar2.67182604.png";